__turbopack_context__.v({
  "popular-searches": "MjuiOG_popular-searches",
  "wrap": "MjuiOG_wrap",
});
